export default __webpack_public_path__ + "static/apparel-bce3ab6a773cb68b5b1953e91d1a4141.webp";